import React, { useEffect, useState, useContext } from "react";
import {
	Box,
	Typography,
	Grid,
	Card,
	CardMedia,
	CardContent,
	Button,
	CircularProgress,
	Dialog,
	DialogContent,
	IconButton,
	Fab,
	Snackbar,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Barra } from "../components/Barra";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RefreshIcon from "@mui/icons-material/Refresh";
import axios from "axios";

const colors = {
	titulo: "#182844",
	primario: "#102A8A",
	alerta: "#AA0000",
};

const BancoImagenes = () => {
	const { unidadId } = useParams();
	const { user } = useContext(AuthContext);
	const [imagenes, setImagenes] = useState([]);
	const [cargando, setCargando] = useState(false);
	const [nombreUnidad, setNombreUnidad] = useState("");
	const [codigoUnidad, setCodigoUnidad] = useState("");
	const [nombreAsignatura, setNombreAsignatura] = useState("");
	const [codigoAsignatura, setCodigoAsignatura] = useState("");
	const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
	const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
	const [open, setOpen] = React.useState(false);

	const handleClick = () => {
		setOpen(true);
	};

	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setOpen(false);
	};

	const fetchUnidadYAsignatura = async () => {
		try {
			const unidadRes = await axios({
				method: "get",
				url: `${process.env.REACT_APP_URL_APP}unidades/unidad/${unidadId}`,
				headers: {
					Authorization: "Bearer " + user.authorization.token,
				},
			});
			const unidad = unidadRes.data;
			setNombreUnidad(unidad.name || "");
			setCodigoUnidad(unidad.codigo || "");

			const asignaturaRes = await axios({
				method: "get",
				url: `${process.env.REACT_APP_URL_APP}asignaturas/asignatura/${unidad.asignatura_id}`,
				headers: {
					Authorization: "Bearer " + user.authorization.token,
				},
			});
			const asignatura = asignaturaRes.data;
			setNombreAsignatura(asignatura.name || "");
			setCodigoAsignatura(asignatura.codigo || "");
		} catch (error) {
			console.error("Error al obtener unidad o asignatura:", error);
		}
	};

	const fetchImagenes = async () => {
		setCargando(true);
		try {
			const config = {
				method: "get",
				url: `${process.env.REACT_APP_URL_APP}images/${unidadId}`,
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user.authorization.token,
				},
			};
			const response = await axios(config);
			setImagenes(response.data.images || []);
		} catch (error) {
			console.error("Error al cargar las imágenes:", error);
		} finally {
			setCargando(false);
		}
	};

	const handleGenerarImagen = async () => {
		setCargando(true);
		try {
			const url = `${process.env.REACT_APP_URL_APP}images`;
			const config = {
				method: "post",
				url,
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user.authorization.token,
				},
				data: {
					id: unidadId,
					rut: user.rut,
				},
			};
			const response = await axios(config);
			console.log("Imagen generada:", response.data);
			fetchImagenes();
			handleClick();
		} catch (error) {
			console.error("Error al generar la imagen:", error);
		} finally {
			setCargando(false);
		}
	};

	const agruparImagenes = () => {
		const agrupadas = {};
		imagenes.forEach((img) => {
			const baseKey = img.key
				.replace("-watermark", "")
				.replace("-preview", "")
				.replace(".png", "");
			if (!agrupadas[baseKey]) agrupadas[baseKey] = {};
			if (img.key.includes("preview")) {
				agrupadas[baseKey].preview = img;
			} else if (img.key.includes("watermark")) {
				agrupadas[baseKey].conWatermark = img;
			} else {
				agrupadas[baseKey].sinWatermark = img;
			}
		});
		return Object.values(agrupadas).filter((grupo) => grupo.preview);
	};

	const imagenesAgrupadas = agruparImagenes();

	const handleOpenModal = (index) => {
		setIndiceSeleccionado(index);
		setImagenSeleccionada(
			imagenesAgrupadas[index]?.preview ||
				imagenesAgrupadas[index]?.conWatermark
		);
	};

	const handleCloseModal = () => {
		setImagenSeleccionada(null);
	};

	const handleAnterior = () => {
		const nuevoIndice =
			(indiceSeleccionado - 1 + imagenesAgrupadas.length) %
			imagenesAgrupadas.length;
		setIndiceSeleccionado(nuevoIndice);
		setImagenSeleccionada(
			imagenesAgrupadas[nuevoIndice]?.preview ||
				imagenesAgrupadas[nuevoIndice]?.conWatermark
		);
	};

	const handleSiguiente = () => {
		const nuevoIndice = (indiceSeleccionado + 1) % imagenesAgrupadas.length;
		setIndiceSeleccionado(nuevoIndice);
		setImagenSeleccionada(
			imagenesAgrupadas[nuevoIndice]?.preview ||
				imagenesAgrupadas[nuevoIndice]?.conWatermark
		);
	};

	useEffect(() => {
		fetchUnidadYAsignatura();
		fetchImagenes();
	}, [unidadId]);

	const action = (
		<React.Fragment>
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				onClick={handleClose}
			>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	return (
		<>
			<Barra />
			<Box p={4} mt={10}>
				<Typography
					variant="h5"
					gutterBottom
					sx={{ color: colors.titulo }}
				>
					Banco de Imágenes de la Unidad
				</Typography>
				<Typography
					variant="subtitle1"
					gutterBottom
					sx={{ color: colors.titulo }}
				>
					Asignatura: {nombreAsignatura} ({codigoAsignatura}) | Unidad{" "}
					{codigoUnidad}: {nombreUnidad}
				</Typography>
				{/* <IconButton aria-label="delete">
          <RefreshIcon />
        </IconButton> */}
				{cargando ? (
					<Box display="flex" justifyContent="center" mt={4}>
						<CircularProgress sx={{ color: colors.primario }} />
					</Box>
				) : imagenes.length === 0 ? (
					<Typography
						variant="body1"
						mt={4}
						align="center"
						sx={{ color: colors.alerta }}
					>
						No hay imágenes disponibles para esta unidad.
					</Typography>
				) : (
					<Grid container spacing={2}>
						{imagenesAgrupadas.map((grupo, index) => (
							<Grid
								item
								xs={6}
								sm={4}
								md={3}
								lg={2}
								key={grupo.conWatermark.image_id}
							>
								<Card
									onClick={() => handleOpenModal(index)}
									sx={{
										cursor: "pointer",
										borderRadius: 2,
										boxShadow: 2,
									}}
								>
									<CardMedia
										component="img"
										height="160"
										image={grupo.preview.path}
										alt={grupo.preview.config_titulo}
										sx={{ objectFit: "cover" }}
									/>
									<CardContent sx={{ textAlign: "center" }}>
										<Button
											variant="outlined"
											size="small"
											onClick={() =>
												handleOpenModal(index)
											}
											sx={{
												color: colors.primario,
												borderColor: colors.primario,
											}}
										>
											🔍 Ver imagen
										</Button>
									</CardContent>
								</Card>
							</Grid>
						))}
					</Grid>
				)}

        <Box mt={4} display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleGenerarImagen}
            sx={{ backgroundColor: colors.primario }}
          >
            Generar Imagen
          </Button>
        </Box>

				<Dialog
					open={!!imagenSeleccionada}
					onClose={handleCloseModal}
					maxWidth="md"
					fullWidth
				>
					<DialogContent
						sx={{
							position: "relative",
							textAlign: "-webkit-center",
							WebkitTextAlign: "center",
							p: 2,
						}}
					>
						<IconButton
							onClick={handleCloseModal}
							sx={{
								position: "absolute",
								top: 8,
								right: 8,
								color: colors.alerta,
							}}
						>
							<CloseIcon />
						</IconButton>
						<IconButton
							onClick={handleAnterior}
							sx={{
								position: "absolute",
								top: "50%",
								left: 8,
								transform: "translateY(-50%)",
								color: colors.primario,
							}}
						>
							<ArrowBackIosNewIcon />
						</IconButton>
						<img
							src={
								imagenesAgrupadas[indiceSeleccionado]?.preview
									?.path ||
								imagenesAgrupadas[indiceSeleccionado]
									?.conWatermark?.path
							}
							alt={
								imagenesAgrupadas[indiceSeleccionado]
									?.conWatermark?.config_titulo
							}
							style={{
								maxWidth: "100%",
								maxHeight: "80vh",
								borderRadius: 8,
							}}
						/>
						<IconButton
							onClick={handleSiguiente}
							sx={{
								position: "absolute",
								top: "50%",
								right: 8,
								transform: "translateY(-50%)",
								color: colors.primario,
							}}
						>
							<ArrowForwardIosIcon />
						</IconButton>

						<Box
							mt={2}
							display="flex"
							justifyContent="center"
							gap={2}
						>
							<Button
								variant="contained"
								sx={{ backgroundColor: colors.primario }}
								onClick={() => {
									const url =
										imagenesAgrupadas[indiceSeleccionado]
											?.conWatermark?.path;
									if (url) window.open(url, "_blank");
								}}
							>
								Imagen con marca de agua
							</Button>

							<Button
								variant="outlined"
								sx={{
									color: colors.primario,
									borderColor: colors.primario,
								}}
								onClick={() => {
									const url =
										imagenesAgrupadas[indiceSeleccionado]
											?.sinWatermark?.path ||
										imagenesAgrupadas[indiceSeleccionado]
											?.conWatermark?.path;
									if (url) window.open(url, "_blank");
								}}
							>
								Imagen original
							</Button>
						</Box>

						<Typography
							variant="subtitle1"
							mt={2}
							sx={{ color: colors.titulo }}
						>
							{imagenSeleccionada?.config_titulo}
						</Typography>
					</DialogContent>
				</Dialog>

				<Fab
					sx={{ position: "absolute", bottom: 16, right: 16 }}
					aria-label={"Refrescar imagenes"}
					color={"primary"}
          onClick={fetchImagenes}
				>
					<RefreshIcon />
				</Fab>

				<Snackbar
					open={open}
					autoHideDuration={9000}
					onClose={handleClose}
          backgroundColor="red"
					message="La/s imagen/es se están generando. Esto puede tardar unos minutos. pulsa el botón de refrescar para actualizar."
					action={action}
				/>
			</Box>
		</>
	);
};

export default BancoImagenes;
